import type { FC, ReactNode } from 'react'

import { Check, House, X } from 'lucide-react'
import { cn } from '@/lib/utils'

import { EXTERIOR_ONLY } from '@/content/business'

interface ExteriorOnlyPanelProps {
    className?: string
    compact?: boolean
}

const ExteriorOnlyPanel: FC<ExteriorOnlyPanelProps> = ({ className, compact = false }): ReactNode => {
    return (
        <section
            aria-labelledby='exterior-only-heading'
            className={cn('mx-auto max-w-7xl px-4 sm:px-6 lg:px-8', compact ? 'py-8' : 'py-14', className)}
        >
            <div className='overflow-hidden rounded-3xl border-2 border-gold/50 bg-[#fffaf0]' data-reveal>
                <div className='flex flex-col gap-4 border-b border-gold/30 p-6 sm:flex-row sm:items-center sm:p-8'>
                    <span className='flex size-14 shrink-0 items-center justify-center rounded-2xl bg-gold text-navy-deep'>
                        <House className='size-7' aria-hidden='true' />
                    </span>

                    <div>
                        <h2 id='exterior-only-heading' className='text-2xl font-bold sm:text-3xl'>
                            We work on the outside of your home
                        </h2>

                        <p className='mt-2 text-lg'>
                            {EXTERIOR_ONLY.statement}
                        </p>
                    </div>
                </div>

                <div className='grid gap-0 sm:grid-cols-2'>
                    <div className='p-6 sm:p-8'>
                        <h3 className='text-xl font-bold'>
                            We do
                        </h3>

                        <ul className='mt-4 space-y-3'>
                            {EXTERIOR_ONLY.weDo.map(item => (
                                <li key={item} className='flex items-start gap-3'>
                                    <span className='mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full bg-[#1f7a4d] text-white'>
                                        <Check className='size-4' aria-hidden='true' />
                                    </span>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className='border-t border-gold/30 p-6 sm:border-l sm:border-t-0 sm:p-8'>
                        <h3 className='text-xl font-bold'>
                            We don&apos;t
                        </h3>

                        <ul className='mt-4 space-y-3'>
                            {EXTERIOR_ONLY.weDont.map(item => (
                                <li key={item} className='flex items-start gap-3'>
                                    <span className='mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full bg-[#9b2c2c] text-white'>
                                        <X className='size-4' aria-hidden='true' />
                                    </span>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ExteriorOnlyPanel
